import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tellent-assistant-part-fallback',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span class="pill">🔧 {{ reason() }}</span>`,
  styles: [
    `
      :host {
        display: inline-block;
      }
      .pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 10px;
        background: var(--color-muted);
        border-radius: 999px;
        font-size: 0.85em;
        color: var(--color-text-low-default);
      }
    `,
  ],
})
export class TellentAssistantPartFallbackComponent {
  public readonly reason = input.required<string>();
  public readonly payload = input<unknown>();
}
